export enum ExplanationDisplayType {
    both = 'both',
    yes = 'yes',
    no = 'no'
}
